module.exports = __webpack_public_path__ + "static/img/blog_banner.6864d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog_banner.png
// module id = HsME
// module chunks = 1